var map = {
	"./apple.png": 8302,
	"./bar.png": 4034,
	"./bell.png": 7379,
	"./board.png": 6978,
	"./decrease.png": 3936,
	"./god_1.png": 2198,
	"./god_10.png": 4849,
	"./god_11.png": 4700,
	"./god_12.png": 7824,
	"./god_13.png": 9029,
	"./god_14.png": 1696,
	"./god_15.png": 8533,
	"./god_16.png": 3330,
	"./god_17.png": 5477,
	"./god_2.png": 9822,
	"./god_3.png": 6314,
	"./god_4.png": 3931,
	"./god_5.png": 9245,
	"./god_6.png": 3737,
	"./god_7.png": 5274,
	"./god_8.png": 7603,
	"./god_9.png": 5093,
	"./increase.png": 9349,
	"./lucky_bag2.png": 8067,
	"./lucky_bag3.png": 1650,
	"./lucky_bag4.png": 9452,
	"./lucky_bag5.png": 9523,
	"./lucky_thing1.png": 7631,
	"./lucky_thing2.png": 2209,
	"./lucky_thing3.png": 2043,
	"./lucky_thing4.png": 2730,
	"./lucky_thing5.png": 6705,
	"./lucky_thing6.png": 5333,
	"./melon.png": 7657,
	"./orange.png": 8344,
	"./seven.png": 2122,
	"./star.png": 1685,
	"./watermelon.png": 9635
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6255;